import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './mutations';
import licenses from '../modules/licenses';
import paramTables from '../modules/param-tables';
import parameters from '../modules/parameters';
import tabsViews from '../modules/tabs';
import subscribers from '../modules/subscribers';
import vouchersTypes from '../modules/vouchers-types';
import branchOffices from '../modules/branch-offices';
import projects from '../modules/projects';
import branchOfficeWarehouses from '../modules/branchoffices-warehouses';
import contacts from '../modules/contacts';
import contactClerks from '../modules/contacts-clerks';
import contactWarehouses from '../modules/contacts-warehouses';
import contactDocuments from '../modules/contacts-documents';
import departments from '../modules/departments';
import cities from '../modules/cities';
import lines from '../modules/lines';
import cashRegisterSquare from '../modules/cash-register-square';
import balanceCrossing from '../modules/balance-crossing';

import dataSheet from '../modules/data_sheet';

import modaldocs from '../modules/modaldocs';
import transfer from '../modules/transfer';
import account from '../modules/account';
import aurora from '../modules/Aurora';
import starjobs from '../modules/star-jobs';
import various_vouchers from '../modules/various-vouchers';
import transfer_rot from '../modules/transfer-rot';
import kardex from '../modules/kardex';
import clear_erp from '../modules/clear-erp';
import seller_route from '../modules/seller-route';
import rebuild from '../modules/rebuild';
import availabilityInquiry from '../modules/availability-inquiry';

import sublines from "../modules/sublines";
import sublineasB from "../modules/sublinesb";
import users from "../modules/users";
import login from "../modules/login";
import brands from "../modules/brands";
import subbrands from "../modules/subbrands";
import categories from "../modules/categories";
import subcategories from "../modules/subcategories";
import menu from "../modules/menu";
import bannerB2b from "../modules/banners-b2b";
import home from "../b2b/modules/home";
import catalog from "../b2b/modules/catalog";
import ecommerce from "../modules/ecommerce";
import productDetail from "../b2b/modules/product-detail";
import cart from "../b2b/modules/cart";
import relativeProductsForm from "../b2b/modules/relative-products-form";
import ordersHistory from "../b2b/modules/orders-history";
import receivable from "../b2b/modules/receivable";
import replacementAssistant from "../b2b/modules/replacement-assistant";
import statisticsProductSaleClientExclusion from "../b2b/modules/statistics-product-sale-client-exclusion";
import prospective_client from "../modules/prospective-client";
import payment_managment from "../modules/payment-managment";
import products from "../modules/products";
import visits from "../modules/visits";
import listproducts from "../modules/listproducts";
import prices from "../modules/prices";
import documents from "../modules/documents";
import inventories from "../modules/inventories";
import typeoperations from "../modules/types-operations";
import models from "../modules/models";
import taxes from "../modules/taxes";
import promotions from "../modules/promotions";
import baseDocuments from "../modules/base-documents";
import requestheaders from "../modules/request-headers";
import requestproducts from "../modules/request-products";
import inventoryMovements from "../modules/inventory-movements";
import inspectionReport from "../modules/inspection-report";
import projectBalance from "../modules/project-balance";
import certificatesRetentions from "../modules/certificates-retentions";
import nuevoInforme from "../modules/nuevo-informe";

import ordersRetained from "../modules/orders_retained";
import despatch from "../modules/despatch";
import despatchPacking from "../modules/despatch-packing";
import discount from "../modules/discount";
import auxiliarybook from "../modules/auxiliary-book";
import auxiliarybookcontact from "../modules/auxiliary-book-contact";
import reportcommisions from "../modules/report-commisions";
import reportbo from "../modules/report-bo";
import conciliationbalances from "../modules/conciliation-balances";
import accountbalance from "../modules/account-balance";
import statefinaze from "../modules/estados-financieros";
import trialbalance from "../modules/trial-balance";
import trialbalancecontact from "../modules/trial-balance-contact";
import account_comparison from "../modules/account-comparison";
import discountInconsistencies from "../modules/discount-inconsistencies";
import requestService from "../modules/request-service";
import incorporateBankStatement from "../modules/incorporate-bank-statement";
import incorporationConsumption from "../modules/incorporation-consumption";
import discount_soon_payment from "../modules/discount-soon-payment";
import automatic_portfolio_delivery from "../modules/automatic_portfolio_delivery";
import operations_report from "../modules/operations-report";
import dashboard_sale_indicators from "../modules/dashboard-sale-indicators";
import role_dashboard_permissions from "../modules/role-dashboard-permissions";
import roles from "../modules/roles";
import inventoryUsers from "../modules/inventory-users";
import ordersManagement from "../modules/ordersManagement";
import cashReceipts from "../modules/cashReceipts";
import Notifications from "../modules/notifications";
import paymentMethods from "../modules/payment-methods";
import customerAccountStatement from "../modules/customer_account_statement";
import invoiceDetail from "./../modules/invoice_detail";
import reassignSeller from "./../modules/reassign_seller";
import unifyContacts from "./../modules/unify-contacts";
import replacementAssistantAdmin from "../modules/suggested_replacement";
import audit from "./../modules/audit";
import sendDocuments from "./../modules/send_documents";
import report from "./../modules/report";
import reportDynamicMatrix from "./../reports-aggrid/modules/dynamic-matrix";
import cashReceiptsApp from "./../reports-aggrid/modules/cash-receipts-app";
import reportSalesProducts from "./../reports-aggrid/modules/sales-products";
import updateBalances from "./../modules/update_balances";
import fixAssets from "./../modules/fixAssets";
import dateFirm from "./../modules/dateFirm";
import Receivable from "./../modules/receivable";
import ReceivableReport from "./../modules/receivable-report";
import CommissionSaleBrand from "./../modules/commission-sale-brand";
import InventoryReport from "./../modules/inventory-report";
import InventoryReportWms from "./../modules/inventory-report-wms";
import InventoryReposition from "./../modules/inventory-reposition";
import ProjectMovements from "./../modules/project-movements";
import HistoricalReport from "../modules/historical-by-document";
import accountingInventoryMovements from "../modules/accounting-inventory-movements";
import movementsAccountContact from "../modules/movements-account-contact";
import protractorGuide from "../modules/protractor-guide";
import PriceContact from "../modules/prices-contacts";
import IncorporateInventoryInitialBalance from "../modules/incorporate_inventory_initial_balance";
import AccountingDetail from "../modules/accounting-detail";
import reportcommisionsCollection from "../modules/report-commisions-collection";
import ImportAccountingBalances from "../modules/import-saldos-contables";
import ManageInventoryDocuments from "../modules/manage-inventory-documents";
import PickingReport from "../modules/report-picking";
import ExcelInventory from "../modules/excel-inventory";
import BalanceForContacts from "../modules/balance-for-contacts";
import ImportDocumentsPaymentsMethods from "../modules/import-payment-methods-document";
import ProductsEquivalent from "../modules/products_equivalent";
import DeleteDocument from "../modules/delete-documents";
import BalanceReconciliation from "../modules/balance_reconciliation";
import CheckConsignment from "../modules/check-consignment";
import PortfoliorReclassificationAlkosto from "../modules/portfolio_reclassification";
import TableParameters from "../modules/table-parameters";
import Datafonos from "../modules/dataphones";
import MaxMinReport from "../modules/report-max-min";
import reception_documents from '../modules/reception_documents';

import ReportUserDocuments from "../modules/report-user-document";
import ContactBalance from "../modules/contact-balance";
import updateWithholdings from "../modules/update-withholdings";
import TransfersReport from "../modules/report-transfers";
import AccountingConcepts from "../modules/accounting_concept";
import b2c_integration from "../modules/b2c_integration";
import ReportDocumentPendingDispatch from "../modules/report-document-pending-dispatch-order";
import ReportSalesReferrals from "../modules/report-sales-referrals";
import PhysicalInventory from "../modules/physical-inventory";
import ReportLog from "../modules/report-log";

import vehicleStories from "../modules/vehicle-stories";




//import monthlyClosure from "./../modules/monthly_closure";
import sellingPricesAboveCost from "./../modules/selling-prices-above-cost";
import salesDetail from "./../modules/sales-detail";
import salesBudgets from "../modules/sales-budgets";
import salesBudgetByContactsWarehouses from "../modules/sales_budget_by_contacts_warehouses";
import reportSalesBudget from "../reports-aggrid/modules/sales-budget";
import reportSalesBudgetDetail from "../reports-aggrid/modules/sales-budget-detail";
import reportSalesBudgetByContactsWarehouses from "../reports-aggrid/modules/sales_budget_by_contacts_warehouses";
import mailsmasives from "../modules/masive-mails";
import consolidatedKardex from "../modules/consolidated_kardex";
import magneticMedia from "../modules/magneticMedia";
import leaderships from '../modules/leadership'
import schedule from '../modules/schedule'
import contactImport from "../modules/import-terceros";
import productsImport from "../modules/import-products";
import load_images from '../modules/load_images';
import CreateClientComponent from '../modules/clients-component';
import modalPaymentsMethods from "../modules/payments-methods-modal";
import customerDiscountBrand from '../modules/customerDiscountBrand';
import pointOfSale from '../point_of_sale/modules/point_of_sale';
import incorporateInventoryOperations from '../modules/incorporate_inventory_operations';
import inventoryReconciliation from '../modules/inventory-reconciliation';
import documentFinder from '../modules/document_finder';
import idealBalancesImport from "../modules/import-ideal-balances";

import providerAccountStatement from "../modules/provider_account_statement";
import reportSalesPurchases from "../modules/report-sales-purchases";
import reportAccountsPlans from "../modules/import-accounts-plans";
import reportResultEri from "../modules/report-reult-eri";

import incorporateAccountingMovements from '../modules/incorporate_accounting_movements';
import quotations from "../modules/quotations"

import WhatsappApi from '../modules/whatsapp-api'
import mercadoApi from "../modules/mercado-api";
import whatChimpApi from '../modules/whatChimpApi';

import guarantees from '../b2b/modules/guarantees'
import guaranteesAdmin from '../modules/guarantees_admin'
import validateKardex from '../modules/validate-kardex'
import reservationProduct from '../modules/reservationProduct'
import CashRegistersUpdates from "../modules/cash-registers-updates";
import replacementPointsOfSales from '../modules/replacement_points_of_sale';
import modalListProductWms from '../modules/modal-list-product-wms'
import productPricing from '../modules/product-pricing'
import modalAttachments from '../modules/modal-attachments'
import contactVehicles from '../modules/contact-vehicles'
import publicInvoice from '../modules/public-invoice'
import modalUploadProductsExcel from '../modules/modal-upload-products-excel'
import taxLiquidator from '../modules/tax-liquidator'
import consignmentProductsPreInvoice from '../modules/consignment-products-pre-Invoice'
import specialProcesses from '../modules/special-processes'
import productParent from '../modules/product-parent'
import countries from '../modules/countries';
import metaWhatsappApi from '../modules/metaWhatsappApi'
import electronicInvoicingServices from '../modules/electronic-invoicing-services'

Vue.use(Vuex);

//=======vuex store start===========
const store = new Vuex.Store({
    state: {
        left_open: true,
        right_open: false,
        cart_open: false,
        preloader: true,
        user: {
            name: "Addison",
            picture: "images/avatar1.jpg",
            job: "Project Manager"
        }
    },
    mutations,
    modules: {
        productParent,
        consignmentProductsPreInvoice,
        countries,
        electronicInvoicingServices,
        contactVehicles,
        taxLiquidator,
        vehicleStories,
        dateFirm,
        accountingInventoryMovements,
        fixAssets,
        modaldocs,
        projects,
        roles,
        despatch,
        ordersRetained,
        licenses,
        paramTables,
        parameters,
        tabsViews,
        subscribers,
        vouchersTypes,
        branchOffices,
        branchOfficeWarehouses,
        contacts,
        contactClerks,
        contactWarehouses,
        contactDocuments,
        departments,
        cities,
        lines,
        sublines,
        sublineasB,
        users,
        login,
        brands,
        subbrands,
        categories,
        subcategories,
        menu,
        bannerB2b,
        home,
        catalog,
        ecommerce,
        productDetail,
        cart,
        relativeProductsForm,
        ordersHistory,
        receivable,
        replacementAssistant,
        statisticsProductSaleClientExclusion,
        prospective_client,
        payment_managment,
        products,
        visits,
        listproducts,
        prices,
        documents,
        inventories,
        typeoperations,
        models,
        taxes,
        baseDocuments,
        requestheaders,
        requestproducts,
        inventoryMovements,
        certificatesRetentions,
        nuevoInforme,
        promotions,
        automatic_portfolio_delivery,
        dataSheet,
        statefinaze,
        discount_soon_payment,
        cashRegisterSquare,
        discount,
        auxiliarybook,
        accountbalance,
        auxiliarybookcontact,
        reportcommisions,
        reportbo,
        conciliationbalances,
        trialbalance,
        trialbalancecontact,
        account_comparison,
        discountInconsistencies,
        various_vouchers,
        transfer,
        account,
        aurora,
        starjobs,
        transfer_rot,
        kardex,
        clear_erp,
        seller_route,
        availabilityInquiry,
        reception_documents,
        operations_report,
        dashboard_sale_indicators,
        role_dashboard_permissions,
        requestService,
        incorporateBankStatement,
        incorporationConsumption,
        InventoryReport,
        InventoryReportWms,
        InventoryReposition,
        ProjectMovements,
        rebuild,
        inventoryUsers,
        ordersManagement,
        cashReceipts,
        Notifications,
        paymentMethods,
        customerAccountStatement,
        invoiceDetail,
        reassignSeller,
        unifyContacts,
        replacementAssistantAdmin,
        audit,
        sendDocuments,
        report,
        reportDynamicMatrix,
        cashReceiptsApp,
        reportSalesProducts,
        updateBalances,
        ReceivableReport,
        CommissionSaleBrand,
        HistoricalReport,
        Receivable,
        movementsAccountContact,
        balanceCrossing,
        protractorGuide,
        PriceContact,
        sellingPricesAboveCost,
        salesDetail,
        salesBudgets,
        reportSalesBudget,
        reportSalesBudgetDetail,
        mailsmasives,
        leaderships,
        schedule,
        consolidatedKardex,
        contactImport,
        productsImport,
        load_images,
        customerDiscountBrand,
        magneticMedia,
        despatchPacking,
        pointOfSale,
        modalPaymentsMethods,
        CreateClientComponent,
        incorporateInventoryOperations,
        incorporateAccountingMovements,
        inventoryReconciliation,
        documentFinder,
        IncorporateInventoryInitialBalance,
        providerAccountStatement,
        reportSalesPurchases,
        reportAccountsPlans,
        AccountingDetail,
        reportcommisionsCollection,
        ImportAccountingBalances,
        ManageInventoryDocuments,
        reportResultEri,
        PickingReport,
        salesBudgetByContactsWarehouses,
        reportSalesBudgetByContactsWarehouses,
        inspectionReport,
        projectBalance,
        BalanceForContacts,
        quotations,
        ImportDocumentsPaymentsMethods,
        ExcelInventory,
        ProductsEquivalent,
        CheckConsignment,
        DeleteDocument,
        guarantees,
        guaranteesAdmin,
        BalanceReconciliation,
        PortfoliorReclassificationAlkosto,
        validateKardex,
        TableParameters,
        Datafonos,
        MaxMinReport,
        ReportUserDocuments,
        ContactBalance,
        updateWithholdings,
        TransfersReport,
        AccountingConcepts,
        reservationProduct,
        b2c_integration,
        CashRegistersUpdates,
        idealBalancesImport,
        replacementPointsOfSales,
        ReportDocumentPendingDispatch,
        modalListProductWms,
        ReportSalesReferrals,
        PhysicalInventory,
        ReportLog,
        productPricing,
        modalAttachments,
        WhatsappApi,
        mercadoApi,
        whatChimpApi,
        publicInvoice,
        modalUploadProductsExcel,
        specialProcesses,
        metaWhatsappApi,
    }
}); //=======vuex store end===========

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js